// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__caQR6","overflowing":"ReadFullNote_overflowing__3Z0fp"};